// Note: When Unlimited reports are available, BE sends 2147483647 as a max value
export const UNLIMITED_REPORTS_COUNT = 2147483647;
export const UNLIMITED_PLAN_DURATION_TYPE = 'Unlimited';
